<div>
  <!-- Error Message -->
  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''" aria-label="Close"></button>
  </div>

  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h5 class="mb-0">
      <i class="bi bi-journal-text me-2"></i>
      Spray Records
      <span *ngIf="!loading" class="badge bg-secondary ms-2">{{ totalRecords }}</span>
    </h5>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 text-muted">Loading spray records...</p>
  </div>

  <!-- Content -->
  <div *ngIf="!loading && !errorMessage">
    <!-- Empty State -->
    <div *ngIf="records.length === 0" class="text-center py-5 text-muted">
      <i class="bi bi-journal-text fs-1 d-block mb-3"></i>
      <p>No spray records found for this organization</p>
    </div>

    <!-- Spray Records Table -->
    <div *ngIf="records.length > 0">
      <div class="table-responsive">
        <table class="table data-table table-hover mb-0">
          <thead>
            <tr>
              <th>Field Name</th>
              <th>Crop Type</th>
              <th>Customer</th>
              <th>Application Date</th>
              <th>Status</th>
              <th>Total Acreage</th>
              <th>Pilot</th>
              <th>Drones</th>
              <th>Chemicals</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let record of records"
              class="cursor-pointer"
              (click)="navigateToRecord(record)"
            >
              <td>
                <span class="fw-medium">{{ record.fieldName || '-' }}</span>
              </td>
              <td>{{ record.cropType || '-' }}</td>
              <td>{{ record.customerName || '-' }}</td>
              <td>{{ formatDate(record.applicationDate) }}</td>
              <td>
                <span class="badge" [ngClass]="getStatusBadgeClass(record.status)">
                  {{ getStatusText(record.status) }}
                </span>
              </td>
              <td>{{ record.totalAcreage }} ac</td>
              <td>{{ record.pilotName || '-' }}</td>
              <td>
                <span class="text-truncate d-inline-block" style="max-width: 150px;">
                  {{ getDroneNames(record.droneNames) }}
                </span>
              </td>
              <td>
                <span class="text-truncate d-inline-block" style="max-width: 150px;">
                  {{ getChemicalNames(record.chemicals) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Footer -->
      <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalRecords > 0">
        <div class="text-muted">
          Showing {{ showingStart }} to {{ showingEnd }} of {{ totalRecords }} records
        </div>
        <nav *ngIf="totalPages > 1">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <button class="page-link" (click)="onPageChange(currentPage - 1)">
                <i class="bi bi-chevron-left"></i>
              </button>
            </li>
            <li
              *ngFor="let page of paginationRange"
              class="page-item"
              [class.active]="page === currentPage"
            >
              <button class="page-link" (click)="onPageChange(page)">{{ page }}</button>
            </li>
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <button class="page-link" (click)="onPageChange(currentPage + 1)">
                <i class="bi bi-chevron-right"></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
